import removeControlsViewerMayNotUse from "../javascripts/viewerControls.js";

const frontPage = () => {

    // Helper function to show error alerts
    const showErrorAlert = (message, videoId) => {
        // Remove any existing error alerts for this video
        const existingAlert = document.getElementById(`error-alert-${videoId}`);
        if (existingAlert) {
            existingAlert.remove();
        }

        // Create alert element
        const alertDiv = document.createElement('div');
        alertDiv.id = `error-alert-${videoId}`;
        alertDiv.className = 'alert alert-danger alert-dismissible fade show position-fixed';
        alertDiv.style.cssText = 'top: 20px; right: 20px; z-index: 9999; max-width: 400px; box-shadow: 0 4px 12px rgba(0,0,0,0.3);';
        alertDiv.innerHTML = `
            <strong><i class="bi bi-exclamation-triangle-fill me-2"></i>Upload Failed</strong>
            <p class="mb-0 mt-2"></p>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        `;
        // The job's error message can carry a filename or URL: text, not HTML.
        alertDiv.querySelector('p').textContent = message;

        document.body.appendChild(alertDiv);

        // Auto-dismiss after 15 seconds
        setTimeout(() => {
            if (alertDiv.parentNode) {
                alertDiv.classList.remove('show');
                setTimeout(() => alertDiv.remove(), 150);
            }
        }, 15000);
    };

    // Check URL for job_i parameter and check job status
    const checkJobStatus = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const jobId = urlParams.get('job_i');

        if (!jobId) return;

        try {
            const response = await fetch(`/videos/job_status/${jobId}`);
            if (response.ok) {
                const data = await response.json();
                if (data.status === 'failed' || data.error_message) {
                    showErrorAlert(data.error_message || 'Job failed with unknown error', data.video_id || 'unknown');
                }
            }
        } catch (e) {
            // console.log('Could not check job status:', e);
        }
    };

    // Check job status on page load
    checkJobStatus();

    const videos = document.querySelectorAll('.copy-button-group');
    videos.forEach(function (video) {
        const copyButton = video.querySelector('.btn');
        const shortcodeInput = video.querySelector('input');
        copyButton.addEventListener('click', function () {
            if (navigator.clipboard == undefined) {
                alert("Your browser does not support the clipboard API. Please copy the shortcode manually.");
                return;
            }
            navigator.clipboard.writeText(shortcodeInput.value).then(function () {
                // Success feedback here. For example:
                // console.log('Copying to clipboard was successful!');
            }, function (err) {
                // Error feedback here. For example:
                console.error('Could not copy text: ', err);
            });
        });
    });


    // const slackNameField = document.getElementById("slack_name");
    // const savedSlackName = localStorage.getItem("slack_name");
    // if (savedSlackName) {
    //     slackNameField.value = savedSlackName;
    // }
    //
    // slackNameField.addEventListener("change", function () {
    //     const slackName = slackNameField.value;
    //     localStorage.setItem("slack_name", slackName);
    // });


    const processedCountEl = document.getElementById('processed_count');
    const processingCountEl = document.getElementById('processing_count');
    const queStatsEl = document.getElementById('queue_status_group');
    const processedContainerEl = document.getElementById('processed-container');
    //const processingContainerEl = document.getElementById('processing_group');

    const updateStatus = (vidID, status) => {
        let vidStatusEl = document.getElementById(`status_label_video_${vidID}`);
        if (vidStatusEl) {
            vidStatusEl.innerText = status;
        }
    }
    const updateLastLogTime = (vidID, last_log_time_words) => {
        let vidThumbnailEl = document.getElementById(`last_log_time_in_words_video${vidID}`);
        // console.log(`last_log_time_in_words_video_${vidID}`, vidThumbnailEl, last_log_time_words);

        if (vidThumbnailEl) {
            vidThumbnailEl.innerText = last_log_time_words;
        }
    }


    const updateThumbnail = (vidID, thumbnail_url) => {
        let vidThumbnailEl = document.getElementById(`p_thumb_video_${vidID}`);
        // console.log(`p_thumb_video_${vidID}`, vidThumbnailEl, thumbnail_url);

        if (vidThumbnailEl) {
            vidThumbnailEl.src = thumbnail_url;
        }
    }
    window.fpChannel = App.cable.subscriptions.create({channel: "FrontPageChannel"}, {
        connected() {
             console.log("Connected to FrontPage channel:", this);
        },
        disconnected() {
             console.log("Disconnected from FrontPage channel:", this);
        },
        received(data) {
            window.last_message = data;
            const log_socket_messages = document.querySelector('#log_socket_messages');
            if (log_socket_messages?.checked) {
                if (data.type != "system_status") console.log("Socket Message:", data.type, data);
            }
            switch (data.type) {
                case "system_status":
                    if (processedCountEl) {
                        processedCountEl.innerText = data.processed_count;
                    }
                    if (processingCountEl) {
                        processingCountEl.innerText = data.processing_count;
                    }
                    if (queStatsEl) {
                        queStatsEl.innerHTML = data.que_stats;
                    }
                    break;
                case "video_log":
                    let tempDiv = document.createElement("div");
                    tempDiv.innerHTML = data.log;
                    let newElement = tempDiv.firstElementChild;

                    let logEl = document.getElementById('log_video_' + data.id);
                    if (logEl == null) {
                        return;
                    }
                    logEl.insertBefore(newElement, logEl.firstElementChild);
                    while (logEl.children.length > 5) {
                        logEl.lastElementChild.remove();
                    }

                    updateStatus(data.id, data.status);
                    updateThumbnail(data.id, data.thumbnail_url);
                    updateLastLogTime(data.id, data.last_log);
                    //card_status.innerText = data.status;
                    break;
                case "video_processing_start":
                    // console.log("video_processing_start", data);
                    let processingContainerEl = document.getElementById('processing_group');
                    if(processingContainerEl == null){
                        // console.log("processingContainerEl is null");
                        return;
                    }
                    let card_id = "status_video_" + data.id;
                    let statusCard = document.getElementById(card_id);
                    if (statusCard == null) {
                        // console.log("statusCard is null, adding");
                        processingContainerEl.insertAdjacentHTML('afterbegin', data.message);
                        removeControlsViewerMayNotUse(processingContainerEl);
                    }else{
                        // console.log("statusCard is not null");
                    }

                    break;
                case "video_processing_end":
                    window.end_message = data;
                    let card_id_end = "status_video_" + data.id;
                    let card_status = document.getElementById(card_id_end);
                    let hide = true;
                    if (card_status != null && hide) {
                        card_status.firstElementChild.classList.add("border-success");
                        setTimeout(() => {
                            card_status.firstElementChild.classList.remove("show");
                            setTimeout(() => {
                                card_status.remove();
                                // processedContainerEl.firstElementChild.insertAdjacentHTML('afterbegin', data.message.card_html);
                                // let grid = document.getElementById('grid');
                                // window.imagesLoaded(grid, function () {
                                //     window.updateGrid();
                                // });
                                //setTimeout(() => { window.updateGrid(); }, 1000);
                            }, 20);
                        }, 30);

                    }
                    break;

                case "video_processing_error":
                    console.error("Video processing error:", data);
                    window.last_error = data;

                    // Find existing status card and replace with error card
                    let error_card_id = "status_video_" + data.id;
                    let existing_card = document.getElementById(error_card_id);

                    if (existing_card) {
                        // Replace the existing card with the error card
                        existing_card.outerHTML = data.message;
                    } else {
                        // No existing card, add error card to processing group
                        let processingGroup = document.getElementById('processing_group');
                        if (processingGroup) {
                            processingGroup.insertAdjacentHTML('afterbegin', data.message);
                        }
                    }
                    removeControlsViewerMayNotUse(document.getElementById(error_card_id) || document);

                    // Show browser notification if supported
                    if (Notification.permission === "granted") {
                        new Notification("VIPS Upload Failed", {
                            body: data.error_message,
                            icon: "/favicon.ico"
                        });
                    }

                    // Also show an alert for immediate visibility
                    showErrorAlert(data.error_message, data.id);
                    break;
            }

        }
    });

}

export default frontPage;

